import request from '@/utils/request'

export function login(data) {
  return request({
    url: 'alapi/login_submit',
    method: 'POST',
    data
  })
}

export function registerApi(data) {
  return request({
    url: 'alapi/register_submit',
    method: 'POST',
    data
  })
}
export function userInfoApi(data) {
  return request({
    url: 'alapi/user_info',
    method: 'POST',
    data
  })
}
export function userCheckApi(data) {
  return request({
    url: 'alapi/user_check',
    method: 'POST',
    data
  })
}
// 发布
export function publish_informationApi(data) {
  return request({
    url: 'alapi/publish_information',
    method: 'POST',
    data
  })
}
// 发布查询
export function information_listApi(data) {
  return request({
    url: 'alapi/information_list',
    method: 'POST',
    data
  })
}
// 接单
export function take_informationApi(data) {
  return request({
    url: 'alapi/take_information',
    method: 'POST',
    data
  })
}
export function take_information_listApi(data) {
  return request({
    url: 'alapi/take_information_list',
    method: 'POST',
    data
  })
}
// 退单
export function abandonOrderApi(params) {
  return request({
    url: 'alapi/waive_information',
    params
  })
}
// 图片上传
export function resources_insertApi(data) {
  return request({
    url: 'alapi/resources_insert',
    method: 'POST',
    data
  })
}
// 信息修改
export function update_user_infoApi(data) {
  return request({
    url: 'alapi/update_user_info',
    method: 'POST',
    data
  })
}
// 申请展厅
export function applyDisplayApi(data) {
  return request({
    url: 'alapi/add_exhibition_hall',
    method: 'POST',
    data
  })
}
// 完结订单
export function finishOrderApi(params) {
  return request({
    url: 'alapi/success_information',
    params
  })
}
// 收藏
export function likeApi(params) {
  return request({
    url: 'alapi/user_like',
    params
  })
}
// 收藏列表
export function likeListApi(data) {
  return request({
    method:'POST',
    url: 'alapi/like_list',
    data
  })
}
// 我要反馈
export function feedbackApi(data) {
  return request({
    method: 'POST',
    url: 'alapi/feedback',
    data
  })
}
// 待审核列表
export function checkListApi(data) {
  return request({
    method: 'POST',
    url: 'alapi/check_list',
    data
  })
}
// 审核
export function checkActionApi(data) {
  return request({
    method: 'POST',
    url: 'alapi/check_action',
    data
  })
}
